import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from '@/language';
import 'whatwg-fetch'
import VueSpatialNavigation from "vue-spatialnavigation";
import LoadScript from 'vue-plugin-load-script';
import smoothscroll from 'smoothscroll-polyfill';
import scrollIntoView from '@/plugins/scrollIntoView';
import lazyLoadPlugin from '@/plugins/lazyload';
import AnalyticsPlugin from '@/plugins/recordEvent';
import FocusPlugin from '@/plugins/focusPlugin';
import PressPlugin from '@/plugins/pressPlugin';
import SentryPlugin from '@/plugins/sentryPlugin';
import PeachPlugin from '@/plugins/peach'
import LongPressPlugin from '@/plugins/longPressPlugin'
import NielsenPlugin from '@/plugins/nielsen'
import { initScale } from '@/helpers/scale';
import "core-js/features/array/flat-map";

//If screen < 1080 scale up to 1920x1080 design scale
initScale();

window.__forceSmoothScrollPolyfill__ = true;
smoothscroll.polyfill();

//moment.tz.setDefault('Europe/Dublin')

Vue.use(LoadScript);
Vue.use(lazyLoadPlugin);
Vue.use(VueSpatialNavigation)

//Remove mouseover/mouseout event propagation to prevent unwanted focus changes on TV
//Vestel TVs have mousover events that can trigger unwanted focus changes
const swallowMouseEvent = (event: Event) => event.stopPropagation();
document.addEventListener('mouseover', swallowMouseEvent, true);
document.addEventListener('mouseout', swallowMouseEvent, true);
Vue.use(scrollIntoView);
Vue.use(AnalyticsPlugin);
Vue.use(FocusPlugin);
Vue.use(PressPlugin);
Vue.use(SentryPlugin);
Vue.use(LongPressPlugin);
Vue.use(NielsenPlugin);


Vue.prototype.$recordEvent('loaded-app');

Vue.config.productionTip = false


new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  created() {
    Vue.use(PeachPlugin, this.$store)
  }
}).$mount('#app')